import { render } from "./AdminLoginView.vue?vue&type=template&id=154c8858"
import script from "./AdminLoginView.vue?vue&type=script&lang=js"
export * from "./AdminLoginView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__